/**
 * Os produtos que a operação usa hoje, como no protótipo.
 *
 * Vivem fora das telas porque duas janelas cadastram venda — a de Sales e a da
 * Implantação — e listas separadas divergem no primeiro produto novo. As
 * operadoras saíram daqui para um cadastro (NEX-228): `useOperadoras`.
 */

export const PRODUTOS = ['Saúde', 'Odonto', 'Seguro de Vida', 'Seguro Auto', 'Consórcio', 'Outro'];

/** Mantém na lista um valor já gravado que saiu das opções correntes. */
export function comValorAtual(opcoes: string[], atual: string | null | undefined): string[] {
  return atual && !opcoes.includes(atual) ? [atual, ...opcoes] : opcoes;
}
